import React from 'react';

import { LensIcon } from '@depop/web-ui-kit/Icons/LensIcon';
import { Modal } from '@depop/web-ui-kit/Modal';
import clsx from 'clsx';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { SearchBar } from '../index';

import styles from './styles.module.css';

import { ButtonMinimal } from '@/components/ButtonMinimal';
import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { useSearchBarModal } from '@/modules/search/useSearchBarModal';

type Props = {
  isCompact?: boolean;
};

export function SearchBarModal({ isCompact = false }: Props) {
  const pathname = usePathname();
  const isSearchPage = pathname === '/search';
  const { isOpen, setIsOpen } = useSearchBarModal();
  const t = useTranslations('common');

  const title = 'Search';

  const { web_6599_search_bar_ds_rollout } = useExperiments([
    'web_6599_search_bar_ds_rollout',
  ]);
  const isDesignSystemVariant =
    web_6599_search_bar_ds_rollout === VARIANT_IDENTIFIER;

  return (
    <>
      <ButtonMinimal
        className={clsx(styles.searchButton, {
          [styles['searchButton--compact']]: isCompact,
        })}
        onClick={() => setIsOpen(true)}
        aria-haspopup="dialog"
        aria-controls="search-bar-modal"
        aria-label={t('Search.Placeholder')}
      >
        <LensIcon
          className={clsx(styles.searchIcon, {
            [styles[`searchIcon--isActive`]]: isSearchPage,
          })}
          type="lens"
        />
      </ButtonMinimal>
      <Modal
        hideCloseButton={isDesignSystemVariant}
        isOpen={isOpen}
        setOpen={setIsOpen}
        ignoreModalFocus
        content={() => <SearchBar isAutoFocused setIsOpen={setIsOpen} />}
        title={title}
        id="search-bar-modal"
        overlayAriaLabel={title}
      />
    </>
  );
}
